/**
 * @generated SignedSource<<3f1faca26ee90665fd67354c50fcf0df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVDashboardPickerPopoverItem_dashboard$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TVDashboardPickerPopoverItem_dashboard";
};
export type TVDashboardPickerPopoverItem_dashboard$key = {
  readonly " $data"?: TVDashboardPickerPopoverItem_dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerPopoverItem_dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVDashboardPickerPopoverItem_dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "dd054a636790d5e9c787d38aac7430d5";

export default node;
